import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../components/details.css';
import { Gateway } from '../BaseUrl';
import { shortDateString, TelephoneType } from '../Functions/Generic';

export class Details extends Component {
    displayName = Details.name

    constructor(props) {
        super(props);
        this.props.changeLogo("user");

        this.state = {
            name: this.props.name,
            address: this.props.address,
            emailAddress: this.props.emailAddress,
            dateOfBirth: this.props.dateOfBirth,
            phoneNumbers: this.props.phoneNumbers,
            personIds: this.props.personIds
        };

    }

    render() {
        return (
            <div className="details-page-container" style={{ width: "100%" }}>
                <div className="desktop-only">
                    <div className="large-title">
                        <h2 className="text-center"> Your Details </h2>
                    </div>
                </div>
                <div className="container details-container">
                    <h1 className="mobile-only">Your Details</h1>
                    <Personal name={this.state.name} dateOfBirth={this.state.dateOfBirth} />
                    <hr className="mobile-only" />
                    <PhoneNumbers phoneNumbers={this.state.phoneNumbers} />
                    <hr className="mobile-only" />
                    <Email emailAddress={this.state.emailAddress} />
                    <hr className="mobile-only" />
                    <Address address={this.state.address} />
                </div>
            </div>
        );
    }
}

const Personal = (props) => {
    return (
        <div style={{ textTransform: "capitalize", maxWidth: "290px"  }}>
            <h3>Personal</h3>
            <div className="personal">
                <p>{props.name.title} {props.name.firstname} {props.name.lastname}</p>
                <p>{shortDateString(props.dateOfBirth.date, "-")}</p>
            </div>
        </div>
    );
}

const PhoneNumbers = (props) => {
    return (
        <div style={{ textTransform: "capitalize", maxWidth: "290px" }}>
            <h3>Telephone</h3>
            {
                props.phoneNumbers.map((item, index) => {
                    return (
                        <div key={index} className="form-group">
                            <label>{TelephoneType(item.telephoneKind)}</label>
                            <p>{item.number} {item.primary && <i style={{ color: "#03bf03"}} className="fas fa-check-circle" />}</p>
                        </div>
                    )
                })
            }
            <div className="form-group text-center">
                <Link to={"/change-numbers"} className="btn btn-lg btn-primary">
                    Change Numbers
                </Link>
            </div>
        </div>
    );
}

const Email = (props) => {
    return (
        <div style={{ maxWidth: "290px" }}>
            <h3>Email</h3>
            <div style={{ textTransform: "lowercase" }}>
                <p>{props.emailAddress.email}</p>
            </div>
            <div className="form-group text-center">
                <Link to={"/change-email"} className="btn btn-lg btn-primary">
                    Change Email Address
                </Link>
            </div>
        </div>
    );
}

const Address = (props) => {
    return (
        <div style={{ textTransform: "capitalize", maxWidth: "290px"  }}>
            <h3>Address</h3>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: "5px" }}>
                <span>{props.address.addressLine1}</span>
                <span>{props.address.addressLine2}</span>
                <span>{props.address.addressLine3}</span>
                <span>{props.address.addressLine4}</span>
                <span>{props.address.addressLine5}</span>
                <span>{props.address.town}</span>
                <span>{props.address.county}</span>
                <span>{props.address.eirCode}</span>
                <span>{props.address.country}</span>
            </div>
            <div className="form-group text-center">
                <Link to={"/change-address"} className="btn btn-lg btn-primary">
                    Change Address
                </Link>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/details.js